<template>
  <div :class="{'form-group': true, 'has-error': error}">
    <label class="col-md-3"><span class="required-label">*</span>{{ label }}</label>
    <div class="col-md-6">
      <input
        type="text"
        :name="name"
        :placeholder="label"
        class="form-control"
        v-model="val"
        v-validate="'required'"
        @change="handleChange"
      >
      <span v-show="error" class="error-label">Isi {{label}}</span>
    </div>
  </div>
</template>

<script>
import api from '@/api'

export default {
  data () {
    return {
      val: null,
      error: false
    }
  },
  mounted () {
    this.$root.$on('input-khusus-validate', this.validate)
    api.get(`/v2/data_khusus/${this.nomorPendaftar}/${this.name}`)
      .then(response => {
        this.val = response.data.data.value
        this.$emit('input-text-change', {name: this.name, value: response.data.data.value})
      })
      .catch(e => {
        this.$emit('input-text-change', {name: this.name, value: null})
      })
  },
  computed: {
    nomorPendaftar () {
      return this.$store.getters.getAuthData.data.mhs_jalur.nomor_pendaftar
    }
  },
  props: ['name', 'label'],
  methods: {
    handleChange () {
      this.$emit('input-text-change', {name: this.name, value: this.val})
      this.validate()
    },
    validate () {
      this.val === '' || this.val === null ? this.error = true : this.error = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/Text.vue